<template>
  <v-card class="files-save-panel">
    <div class="files-save-header">
      <v-icon small class="mr-1">mdi-content-save</v-icon>
      Save selected pages
    </div>

    <div class="files-save-body">
      <div v-if="selectedPages.length" class="mb-3">
        <div class="files-save-count mb-2">
          {{ selectedPages.length }}
          {{ selectedPages.length === 1 ? "page" : "pages" }} selected
        </div>
        <v-chip
          v-for="page in selectedPages"
          :key="page.key"
          small
          class="ma-1"
          outline
          color="success"
        >
          {{ page.fileName }} · p.{{ page.pageNumber }}
        </v-chip>
      </div>
      <div v-else class="files-save-empty">
        <v-icon class="files-save-empty-icon"
          >mdi-checkbox-blank-outline</v-icon
        >
        <div>Select pages to save.</div>
      </div>
      <div v-if="selectedPages.length">
        <div class="files-save-label mb-2">
          <v-icon small color="success" class="mr-1">mdi-file-document</v-icon>
          Document details
        </div>
        <v-select
          outline
          hide-details
          class="mb-3"
          label="Save as"
          :items="docTypeItems"
          v-model="selectedDocTypeId"
          @change="selectedStudentId = ''"
        >
          <template slot="item" slot-scope="data">
            <v-list-tile-content>
              <v-list-tile-title
                :class="{ 'missing-doc-type': data.item.isMissing }"
              >
                {{ data.item.description }}
              </v-list-tile-title>
            </v-list-tile-content>
          </template>
        </v-select>

        <v-select
          :menu-props="{ maxHeight: 600 }"
          v-if="selectedDocTypeId && requireStudent"
          outline
          hide-details
          class="mb-3"
          label="Student"
          :items="studentItems"
          v-model="selectedStudentId"
        >
          <template slot="item" slot-scope="data">
            <v-list-tile-content>
              <v-list-tile-title
                :class="{ 'missing-doc-type': data.item.isMissing }"
              >
                {{ data.item.description }}
              </v-list-tile-title>
            </v-list-tile-content>
          </template></v-select
        >

        <v-text-field
          v-if="selectedFileName"
          :readonly="true"
          filled
          flat
          hide-details
          class="mb-3"
          label="Document name"
          required
          v-model="selectedFileName"
        ></v-text-field>

        <v-btn
          color="success"
          block
          class="files-save-btn"
          :disabled="!canSave"
          :loading="saving"
          @click="$emit('save')"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Save document
        </v-btn>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "DocumentSplitterSavePanel",
  props: {
    accountId: {
      type: String,
      default: "",
    },
    students: {
      type: Array,
      default() {
        return [];
      },
    },
    docTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedPages: {
      type: Array,
      default() {
        return [];
      },
    },
    studentId: {
      type: String,
      default: "",
    },
    docTypeId: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedStudentId: {
      get() {
        return this.studentId;
      },
      set(value) {
        this.$emit("update:studentId", value);
        if (value) {
          const student = this.students.find((s) => s.studentID === value);
          const studentName = (
            (student &&
              (student.engName || student.hebName || student.studentID)) ||
            ""
          ).trim();
          this.selectedFileName = `${this.selectedDocTypeId.trim()}_${studentName}_${this.accountId.trim()}`;
        }
      },
    },
    selectedDocTypeId: {
      get() {
        return this.docTypeId;
      },
      set(value) {
        this.$emit("update:docTypeId", value);
        this.selectedFileName = `${value.trim()}_${this.accountId.trim()}`;
      },
    },
    selectedFileName: {
      get() {
        return this.fileName;
      },
      set(value) {
        this.$emit("update:fileName", value);
      },
    },

    studentItems() {
      const items = [];
      this.students.forEach((student) => {
        const name = student.engName || student.hebName || student.studentID;
        const desc = `${
          student.missingImm && this.selectedDocTypeId === "IMM"
            ? "- Missing: " + student.missingImm
            : ""
        }
          ${
            student.missCH205 && this.selectedDocTypeId === "CH205"
              ? "- Missing CH205"
              : ""
          }
        ${
          student.skipcard.includes("12 GRADE APPLICATION NOT SIGNED") &&
          this.selectedDocTypeId === "12G"
            ? "- Missing 12G"
            : ""
        }
        `;
        items.push({
          description: `${name} (${student.class}) ${desc}`,
          isMissing: desc.trim() !== "",
          text: name,
          value: student.studentID,
        });
      });

      return items;
    },

    docTypeItems() {
      return this.docTypes.map((type) => {
        let label = type.docDescription || type.docTypeID;
        if (
          type.docTypeID &&
          type.docDescription &&
          type.docDescription !== type.docTypeID
        ) {
          label = type.docTypeID + " (" + type.docDescription + ")";
        }
        if (type.isMissing) {
          label = label + " Missing";
        }
        const result = {
          ...type,
          text: type.docTypeID,
          description: label,
          value: type.docTypeID,
          color: type.isMissing ? "error" : "success",
        };
        return result;
      });
      //  .sort((a, b) => (b.isMissing ? 1 : 0) - (a.isMissing ? 1 : 0));
    },
    requireStudent() {
      return this.docTypes.find((type) => type.docTypeID === this.docTypeId)
        .requireStudent;
    },

    canSave() {
      if (
        !this.selectedPages.length ||
        this.saving ||
        !this.docTypeId ||
        !this.fileName
      ) {
        return false;
      }
      if (this.requireStudent && !this.studentId) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style>
.files-save-panel {
  position: sticky;
  top: 16px;
  border-radius: 8px !important;
  overflow: hidden;
}

.files-save-header {
  display: flex;
  align-items: center;
  background: #4caf50;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 16px;
}

.files-save-header .v-icon {
  color: #fff !important;
}

.files-save-body {
  padding: 16px;
}

.files-save-count {
  font-size: 12px;
  font-weight: 700;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.files-save-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #4caf50;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.files-save-empty {
  text-align: center;
  color: #9e9e9e;
  padding: 24px 8px 8px;
  font-size: 13px;
}

.files-save-empty-icon {
  display: block;
  font-size: 36px !important;
  color: #c8e6c9 !important;
  margin-bottom: 8px;
}

.files-save-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  margin-top: 4px;
}

.missing-doc-type {
  color: #f44336 !important;
}
</style>
